export const COLUMNS = [
  {
    Header: "Code",
    Footer: "Code",
    accessor: "code",
    sticky: "left",
  },
  {
    Header: "Name",
    Footer: "Name",
    accessor: "name",
    disableFilters: true,
    sticky: "left",
  },

  {
    Header: "Event",
    Footer: "Event",
    accessor: "event",
  },

  {
    Header: "Status",
    Footer: "Status",
    accessor: "isactive",
  },

  {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];
